<template>
	<a-modal
		class="g-header-hero-edit-modal"
		:visible="visible"
		title="头部模块编辑"
		width="618px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-header-hero-edit" @click="clearPanel">
			<div
				class="g-header-hero-edit__preview"
				:style="previewStyle"
				@click.stop
			>
				<UploadProgressPanel
					v-if="isUploading"
					:tasks="uploadTasks"
					variant="item"
					hide-filename
				/>
				<template v-else>
				<img
					v-if="showBackgroundImage"
					:src="bgUrl"
					class="g-header-hero-edit__preview-bg"
					alt=""
				/>
				<div
					v-if="form.darkOverlay && showBackgroundImage"
					class="g-header-hero-edit__preview-overlay"
				></div>
				<div class="g-header-hero-edit__preview-content">
					<img
						v-if="form.showLogo && logoUrl"
						:src="logoUrl"
						class="g-header-hero-edit__preview-logo"
						alt=""
					/>
					<input
						v-model="form.title"
						type="text"
						class="g-header-hero-edit__title-input"
						:style="{ color: form.titleColor }"
						maxlength="40"
						placeholder="输入主标题"
					/>
					<input
						v-model="form.subtitle"
						type="text"
						class="g-header-hero-edit__subtitle-input"
						:style="{ color: form.subtitleColor }"
						maxlength="60"
						placeholder="输入副标题"
					/>
					<input
						v-model="form.buttonText"
						type="text"
						class="g-header-hero-edit__button-input"
						:style="buttonInputStyle"
						:size="buttonInputSize"
						maxlength="20"
						placeholder="按钮文字"
					/>
				</div>
				</template>
			</div>

			<div class="g-header-hero-edit__panel" @click.stop>
				<div class="g-header-hero-edit__link-row">
					<i class="mbm-iconfont mbm-lianjie"></i>
					<span :class="{ 'is-empty': !jumpLinkLabel }">{{ jumpLinkLabel || '未设置链接' }}</span>
				</div>
				<div class="g-header-hero-edit__toolbar">
					<button type="button" class="g-header-hero-edit__action" @click="jumpLinkVisible = true">换链接</button>
					<template v-if="isLogoVisible">
						<button
							type="button"
							class="g-header-hero-edit__action is-active"
							@click="hideLogo"
						>隐藏LOGO</button>
						<button type="button" class="g-header-hero-edit__action" @click="triggerLogoSelect">换LOGO</button>
					</template>
					<button
						v-else
						type="button"
						class="g-header-hero-edit__action"
						@click="showLogo"
					>显示LOGO</button>
					<button type="button" class="g-header-hero-edit__action" @click="triggerBgSelect">换底图</button>
					<!-- <button
						type="button"
						class="g-header-hero-edit__action"
						:class="{ 'is-active': form.darkOverlay }"
						@click="toggleDarkOverlay"
					>底图变暗</button> -->
					<button
						type="button"
						class="g-header-hero-edit__action"
						:class="{ 'is-active': !form.showBg }"
						@click="toggleShowBg"
					>隐藏底图</button>
					<span class="g-header-hero-edit__action-wrap">
						<button
							type="button"
							class="g-header-hero-edit__action"
							:class="{ 'is-active': activePanel === 'height' }"
							@click="togglePanel('height')"
						>高度</button>
						<div v-if="activePanel === 'height'" class="g-header-hero-edit__sub-panel">
							<span class="g-header-hero-edit__sub-label">高度 (px)</span>
							<a-input-number
								v-model:value="heightDraft"
								:min="80"
								:max="800"
								:precision="0"
								class="g-header-hero-edit__sub-input"
							/>
							<button type="button" class="g-header-hero-edit__sub-confirm" @click="applyHeight">确定</button>
						</div>
					</span>
					<span class="g-header-hero-edit__action-wrap">
						<button
							type="button"
							class="g-header-hero-edit__action"
							:class="{ 'is-active': activePanel === 'radius' }"
							@click="togglePanel('radius')"
						>圆角</button>
						<div v-if="activePanel === 'radius'" class="g-header-hero-edit__sub-panel">
							<span class="g-header-hero-edit__sub-label">圆角 (px)</span>
							<a-input-number
								v-model:value="radiusDraft"
								:min="0"
								:max="200"
								:precision="0"
								class="g-header-hero-edit__sub-input"
							/>
							<button type="button" class="g-header-hero-edit__sub-confirm" @click="applyRadius">确定</button>
						</div>
					</span>
					<div class="g-header-hero-edit__colors">
						<ColorPicker
							v-model="form.titleColor"
							title="主标题颜色"
							@change="onTitleColorInput"
						/>
						<ColorPicker
							v-model="form.subtitleColor"
							title="副标题颜色"
							@change="onSubtitleColorInput"
						/>
						<ColorPicker
							v-model="form.buttonBgColor"
							title="按钮背景色"
							@change="onButtonBgColorInput"
						/>
						<ColorPicker
							v-model="form.buttonTextColor"
							title="按钮文字颜色"
							@change="onButtonTextColorInput"
						/>
					</div>
				</div>
			</div>
		</div>

		<template #footer>
			<button type="button" class="g-header-hero-edit__footer-btn" @click="onCancel">取消</button>
			<button type="button" class="g-header-hero-edit__footer-btn is-confirm" :disabled="isUploading" @click="onConfirm">确定</button>
		</template>

		<input
			ref="bgInput"
			type="file"
			accept="image/*"
			class="g-header-hero-edit__file-input"
			@change="onBgFileChange"
		/>
		<input
			ref="logoInput"
			type="file"
			accept="image/*"
			class="g-header-hero-edit__file-input"
			@change="onLogoFileChange"
		/>

		<JumpLink
			:visible="jumpLinkVisible"
			:jumpLink="form.jumpLink || emptyJumpLink"
			:linkTypes="['qrcode']"
			@submit="onJumpLinkSubmit"
			@cancel="jumpLinkVisible = false"
		/>
	</a-modal>
</template>

<script>
	import JumpLink from '@/components/jumpLink.vue';
	import ColorPicker from './ColorPicker.vue';
	import { getSwatchBorderColor, normalizeHexColor } from '../utils/richText.js';
	import {
		filterValidLocalFiles,
		revokeLocalImageUrl,
	} from '../utils/localImage.js';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';
	import { createEmptyJumpLink, formatJumpLinkLabel } from '../utils/jumpLink.js';
	import {
		getHeaderHeroDefaults,
		getHeaderHeroImageUrl,
		HEADER_HERO_DEFAULT_HEIGHT,
		HEADER_HERO_DEFAULT_BORDER_RADIUS,
		normalizeHeaderHeroData,
	} from '../utils/headerHero.js';

	export default {
		name: 'GHeaderHeroEditModal',
		components: { JumpLink, UploadProgressPanel, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm', 'cancel'],
		data() {
			return {
				form: getHeaderHeroDefaults(),
				activePanel: '',
				heightDraft: HEADER_HERO_DEFAULT_HEIGHT,
				radiusDraft: HEADER_HERO_DEFAULT_BORDER_RADIUS,
				jumpLinkVisible: false,
				emptyJumpLink: createEmptyJumpLink(),
				isUploading: false,
				uploadTasks: [],
			};
		},
		computed: {
			previewStyle() {
				return {
					height: `${this.form.height}px`,
					borderRadius: `0 0 ${this.form.borderRadius}px ${this.form.borderRadius}px`,
				};
			},
			showBackgroundImage() {
				return this.form.showBg && !!this.bgUrl;
			},
			bgUrl() {
				return getHeaderHeroImageUrl(this.form.image);
			},
			logoUrl() {
				return getHeaderHeroImageUrl(this.form.logo);
			},
			jumpLinkLabel() {
				return formatJumpLinkLabel(this.form.jumpLink);
			},
			buttonInputStyle() {
				return {
					background: this.form.buttonBgColor,
					color: this.form.buttonTextColor,
				};
			},
			isLogoVisible() {
				return this.form.showLogo && !!this.logoUrl;
			},
			buttonInputSize() {
				const text = this.form.buttonText || '按钮文字';
				return Math.max(text.length, 4);
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.activePanel = '';
					this.syncForm();
				}
			},
			value: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			syncForm() {
				this.form = normalizeHeaderHeroData(this.value);
				this.heightDraft = this.form.height;
				this.radiusDraft = this.form.borderRadius;
			},
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			getSwatchStyle(color) {
				const normalized = normalizeHexColor(color);
				return {
					background: normalized,
					borderColor: getSwatchBorderColor(normalized),
				};
			},
			clearPanel() {
				this.activePanel = '';
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'height') {
					this.heightDraft = this.form.height;
				}
			},
			applyHeight() {
				this.form.height = Math.max(80, Number(this.heightDraft) || HEADER_HERO_DEFAULT_HEIGHT);
				this.activePanel = '';
			},
			applyRadius() {
				this.form.borderRadius = Math.max(0, Number(this.radiusDraft) || 0);
				this.activePanel = '';
			},
			showLogo() {
				this.form.showLogo = true;
				if (!this.logoUrl) {
					this.$refs.logoInput?.click();
				}
			},
			hideLogo() {
				this.form.showLogo = false;
			},
			triggerLogoSelect() {
				this.form.showLogo = true;
				this.$refs.logoInput?.click();
			},
			toggleDarkOverlay() {
				this.form.darkOverlay = !this.form.darkOverlay;
			},
			toggleShowBg() {
				this.form.showBg = !this.form.showBg;
			},
			triggerBgSelect() {
				this.form.showBg = true;
				this.$refs.bgInput?.click();
			},
			async onBgFileChange(event) {
				const file = (event.target.files || [])[0];
				event.target.value = '';
				const validFiles = filterValidLocalFiles(file ? [file] : []);
				if (!validFiles.length) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([validFiles[0]]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [validFiles[0]],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					if (this.form.image?.local) {
						revokeLocalImageUrl(this.form.image.previewUrl);
					}
					this.form.image = item;
					this.form.showBg = true;
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			async onLogoFileChange(event) {
				const file = (event.target.files || [])[0];
				event.target.value = '';
				const validFiles = filterValidLocalFiles(file ? [file] : []);
				if (!validFiles.length) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([validFiles[0]]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [validFiles[0]],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					if (this.form.logo?.local) {
						revokeLocalImageUrl(this.form.logo.previewUrl);
					}
					this.form.logo = item;
					this.form.showLogo = true;
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			onTitleColorInput(color) {
				this.form.titleColor = color;
			},
			onSubtitleColorInput(color) {
				this.form.subtitleColor = color;
			},
			onButtonBgColorInput(color) {
				this.form.buttonBgColor = color;
			},
			onButtonTextColorInput(color) {
				this.form.buttonTextColor = color;
			},
			onJumpLinkSubmit(jumpLink) {
				this.form.jumpLink = jumpLink?.type ? { ...jumpLink } : null;
				this.jumpLinkVisible = false;
			},
			onCancel() {
				this.$emit('update:visible', false);
				this.$emit('cancel');
			},
			onConfirm() {
				this.$emit('confirm', normalizeHeaderHeroData(this.form));
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.g-header-hero-edit {
		padding: 4px 0 12px;
	}

	.g-header-hero-edit__preview {
		position: relative;
		overflow: hidden;
		margin-bottom: 16px;
	}

	.g-header-hero-edit__preview-bg {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.g-header-hero-edit__preview-overlay {
		position: absolute;
		inset: 0;
		z-index: 1;
		background: rgba(0, 0, 0, 0.35);
	}

	.g-header-hero-edit__preview-content {
		position: absolute;
		inset: 0;
		z-index: 2;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 24px 28px;
		box-sizing: border-box;
	}

	.g-header-hero-edit__preview-logo {
		max-width: 120px;
		max-height: 48px;
		margin-bottom: 12px;
		object-fit: contain;
	}

	.g-header-hero-edit__title-input,
	.g-header-hero-edit__subtitle-input {
		width: 100%;
		max-width: 520px;
		border: none;
		background: transparent;
		outline: none;
		text-align: center;
	}

	.g-header-hero-edit__title-input {
		font-size: 32px;
		font-weight: 700;
		line-height: 1.4;
	}

	.g-header-hero-edit__subtitle-input {
		margin-top: 10px;
		font-size: 22px;
		font-weight: 400;
		line-height: 1.4;
	}

	.g-header-hero-edit__button-input {
		margin-top: 20px;
		width: fit-content;
		max-width: 100%;
		padding: 10px 28px;
		border: none;
		border-radius: 999px;
		font-size: 18px;
		font-weight: 700;
		line-height: 1.4;
		text-align: center;
		outline: none;
		white-space: nowrap;
		box-sizing: border-box;
		field-sizing: content;
	}

	.g-header-hero-edit__panel {
		width: max-content;
		max-width: 100%;
		border: 1px solid #eceef2;
		border-radius: 4px;
		overflow: visible;
	}

	.g-header-hero-edit__link-row {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 40px;
		padding: 0 10px;
		border-bottom: 1px solid #f0f0f0;
		font-size: 13px;
		color: #666;

		i {
			color: #999;
		}

		.is-empty {
			color: #bbb;
		}
	}

	.g-header-hero-edit__toolbar {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 0;
		min-height: 40px;
		padding: 0 10px;
		width: max-content;
		max-width: 100%;
	}

	.g-header-hero-edit__action {
		border: none;
		background: transparent;
		padding: 0 8px;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;
		line-height: 32px;
		white-space: nowrap;
		flex-shrink: 0;

		&:hover:not(:disabled) {
			color: #1d4ed8;
		}

		&.is-active {
			color: #1d4ed8;
			font-weight: 500;
		}
	}

	.g-header-hero-edit__action-wrap {
		position: relative;
		display: inline-flex;
		align-items: center;
	}

	.g-header-hero-edit__sub-panel {
		position: absolute;
		left: 0;
		top: calc(100% + 6px);
		z-index: 10;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 8px 10px;
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 4px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
		white-space: nowrap;
	}

	.g-header-hero-edit__sub-label {
		font-size: 12px;
		color: #666;
	}

	.g-header-hero-edit__sub-input {
		width: 88px;
	}

	.g-header-hero-edit__sub-confirm {
		border: none;
    background: #285af9;
    color: #fff;
    padding: 0 12px;
    height: 28px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
	}

	.g-header-hero-edit__colors {
		display: flex;
		align-items: center;
		gap: 8px;
		padding-left: 8px;
	}

	.g-header-hero-edit__swatch {
		position: relative;
		width: 18px;
		height: 18px;
		border: 1px solid #d9d9d9;
		border-radius: 2px;
		cursor: pointer;
		flex-shrink: 0;
		overflow: hidden;
	}

	.g-header-hero-edit__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		opacity: 0;
		cursor: pointer;
	}

	.g-header-hero-edit__file-input {
		display: none;
	}

	.g-header-hero-edit__footer-btn {
		min-width: 72px;
		height: 32px;
		padding: 0 16px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		background: #fff;
		font-size: 14px;
		color: #666;
		cursor: pointer;

		&.is-confirm {
			border-color: #285af9;
			background: #285af9;
			color: #fff;
		}

		& + & {
			margin-left: 10px;
		}
	}
</style>
